module.exports = __webpack_public_path__ + "assets/emoticon-4star.8345b7e8.svg";